import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
const RoleBasedRoute = ({ children, allowedRoles }) => {
    const { isAuthenticated, role } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }
         
    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to="/unauthorized" />; 
    }

    return children;
};

export default RoleBasedRoute;
